import React from 'react';

import { ActionTabs, type ActionTabItem, appStrings } from '@backrs_ui/common-ui';

import { useAuth } from '@backrs_ui/grow-ui/src/hooks/useAuth';
import { useGetTaskActionsAndProperties } from '@backrs_ui/grow-ui/src/pages/Priorities/hooks/tasks.hooks';
import { openSignupPrompt } from '@backrs_ui/grow-ui/src/redux/appState/appState';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

type GuideTaskActionProps = Readonly<{
  id: string;
  title: string;
  description: string;
}>;

/** Icon-only "Task" action that opens the new-task dialog prefilled with a guide card's content. */
export const GuideTaskAction: React.FC<GuideTaskActionProps> = ({ id, title, description }) => {
  const { handleOpenNewTaskDialog } = useGetTaskActionsAndProperties();
  const { loggedIn } = useAuth();
  const dispatch = useAppDispatch();

  // The task dialog only mounts for signed-in users, so guests get the signup prompt instead.
  const actions: ActionTabItem[] = [
    {
      id,
      tooltipHoverText: appStrings.modules.actionTabs.task,
      icon: 'BookmarkAdd',
      onClick: () => {
        if (!loggedIn) {
          dispatch(openSignupPrompt());

          return;
        }

        handleOpenNewTaskDialog(null, false, { title, description });
      },
    },
  ];

  return <ActionTabs actions={actions} />;
};
